import { FC } from 'react';

import Link from 'next/link';

import { useMediaQuery } from '@mui/material';

import { MajorCityWard } from '@hooks_iqfu/public/useAreaData';

import { MediaQuery } from '@constants_common';
import { CompaniesPageQueryType } from 'src/iqfu/data/companiesPagesData';

import styles from './MajorCityWardsLinkList.module.scss';

type CompanyPageProps = {
  pageType: 'company';
  majorCityName: string;
  majorCityWardList: MajorCityWard[];
  pageQueryType: CompaniesPageQueryType;
};

type MansionPageProps = {
  pageType: 'mansion';
  majorCityName: string;
  majorCityWardList: MajorCityWard[];
  mansionAreaPrice?: number | null;
};

type LandHousePageProps = {
  pageType: 'landhouse';
  majorCityName: string;
  majorCityWardList: MajorCityWard[];
  landAreaPrice?: number | null;
  houseAreaPrice?: number | null;
};

type Props = CompanyPageProps | MansionPageProps | LandHousePageProps;

//半角スペースを<br />タグに変換する
const convertSpaceToBrTag = (text: string) => {
  return text.replace(/ /g, '<br />');
};

const MajorCityWardsLinkList: FC<Props> = (props) => {
  const { pageType, majorCityName, majorCityWardList } = props;

  const isMobile = useMediaQuery(MediaQuery.lg);
  return (
    <>
      <div className={`${styles.list_container}`}>
        <div className={styles.area_group}>
          <div className={styles.area_group_title_container}>
            {pageType === 'company' ? (
              <h2 className={styles.area_group_title}>
                <span className={styles.area_name}>{majorCityName}</span>
                <span className={styles.area_title_predicate}>各区の不動産屋さんランキングを見る</span>
              </h2>
            ) : (
              <h3 className={styles.area_group_title}>
                <span className={styles.area_name}>{majorCityName}</span>
                <span className={styles.area_title_predicate}>
                  {pageType === 'mansion' ? (
                    <>
                      各区のマンション
                      <br className="sp_only" />
                      の売却査定額
                    </>
                  ) : pageType === 'landhouse' ? (
                    <>
                      各区の土地戸建
                      <br className="sp_only" />
                      の売却査定額
                    </>
                  ) : (
                    <></>
                  )}
                </span>
              </h3>
            )}
            {pageType === 'mansion' && props.mansionAreaPrice && !isNaN(props.mansionAreaPrice) && (
              <div className={styles.mansion_average_price_area}>平均{props.mansionAreaPrice}万円/m2</div>
            )}
            {pageType === 'landhouse' && props.landAreaPrice && props.houseAreaPrice && !isNaN(props.landAreaPrice) && (
              <div className={styles.landhouse_average_price_area}>
                <div className={styles.landhouse_average_price_item}>
                  <span>戸建</span>
                  <span>:平均{props.houseAreaPrice}万円/m2</span>
                </div>
                <div className={styles.landhouse_average_price_item}>
                  <span>土地</span>
                  <span>:平均{props.landAreaPrice}万円/m2</span>
                </div>
              </div>
            )}
          </div>
          <ul className={styles.link_list}>
            {majorCityWardList &&
              majorCityWardList.map((ward, i) => {
                return (
                  <li className={`${styles.link_item}`} key={i}>
                    <Link
                      prefetch={false}
                      href={
                        pageType === 'company'
                          ? `/companies/cities/${ward.code}/${props.pageQueryType}`
                          : pageType === 'mansion'
                          ? `/mansions/cities/${ward.code}`
                          : pageType === 'landhouse'
                          ? `/landhouses/cities/${ward.code}`
                          : ''
                      }
                      className={styles.prefLink}
                      dangerouslySetInnerHTML={{ __html: isMobile ? convertSpaceToBrTag(ward.name) : ward.name }}
                    ></Link>
                  </li>
                );
              })}
          </ul>
        </div>
      </div>
    </>
  );
};

export default MajorCityWardsLinkList;
